import { Column, ColumnEditorOptions } from "primereact/column";
import { DataTable, DataTableRowEditCompleteEvent } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import React from "react";
import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { T } from "services/lang/LanguageService";
import DatasetTitle from "components/basic/display-titles/DatasetTitle";
import { DatasetDataInputTableProps, DatasetObject } from "../DatasetDataInputTableTypes";
import { InputSwitch } from "primereact/inputswitch";

interface DatasetDataInputTableDatasetsEditorProps {
  currentConfig: DatasetDataInputTableProps;
  setCurrentConfig: (config: DatasetDataInputTableProps) => void;
}

const DatasetDataInputTableDatasetsEditor = ({
  currentConfig,
  setCurrentConfig,
}: DatasetDataInputTableDatasetsEditorProps) => {
  const handleOverriddenTitleEditor = (options: ColumnEditorOptions) => {
    return (
      <InputText
        value={options.value || ""}
        className="w-full"
        onChange={e => options.editorCallback?.(e.target.value)}
      />
    );
  };

  const handleInputSwitchEditor = (options: ColumnEditorOptions) => {
    return (
      <InputSwitch
        checked={options.value ?? false}
        onChange={e => options.editorCallback?.(e.value ?? false)}
      />
    )
  }

  const handleRowEditComplete = (e: DataTableRowEditCompleteEvent) => {
    const { newData, index } = e;
    const datasetsToUpdate = [...currentConfig.datasets];
    datasetsToUpdate[index] = newData as DatasetObject;
    setCurrentConfig({ ...currentConfig, datasets: datasetsToUpdate });
  };

  const identifierEditor = (options: ColumnEditorOptions) => {
    return (
      <DatasetDropdown value={options.value || ""} onChange={e => options.editorCallback?.(e)} />
    );
  };

  const titleBodyTemplate = (rowData: DatasetObject) => {
    return <DatasetTitle identifier={rowData.identifier} />;
  };

  const disableEditingBodyTemplate = (rowData: DatasetObject) => {
    return <InputSwitch disabled checked={rowData.disableEditing ?? false} />
  }

  return (
    <DataTable
      value={currentConfig.datasets}
      editMode="row"
      onRowEditComplete={handleRowEditComplete}
    >
      <Column
        field="identifier"
        header={T("word.title")}
        style={{ width: "40%" }}
        editor={identifierEditor}
        body={titleBodyTemplate}
      />
      <Column
        field="overriddenTitle"
        header={T("word.overridden-title")}
        style={{ width: "40%" }}
        editor={handleOverriddenTitleEditor}
      />
      <Column
        field="disableEditing"
        header={T("action.disable-editing")}
        style={{ width: "10%", textAlign: "end" }}
        body={disableEditingBodyTemplate}
        editor={handleInputSwitchEditor}
      />
      <Column rowEditor style={{ width: "10%", textAlign: "end" }} />
    </DataTable>
  );
};

export default DatasetDataInputTableDatasetsEditor;
